import React, { Component } from 'react';
import store from '../store';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import DoneIcon from '@material-ui/icons/Done';

import createHistory from 'history/createBrowserHistory';

import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Input from '@material-ui/core/Input';
import Chip from '@material-ui/core/Chip';
import { Link } from 'react-router-dom';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import BackIcon from '@material-ui/icons/ChevronLeft';
import { Redirect } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import firebase from "firebase/app";
import "firebase/firestore";
import _ from 'lodash'
import LessonComp from "../components/LessonComp"
import ButtonBase from '@material-ui/core/ButtonBase';
import * as STATIC from '../config/static';
import CheckIcon from '@material-ui/icons/Check';
import moment from 'moment';

import Advance from './Advance';
import InnerPage from './InnerPage';
import CircularProgress from '@material-ui/core/CircularProgress';
import TopBar from '../components/TopBar';
const days = [0, 1, 2, 3, 4, 5];
const defaultSetting = {
  type: [],

  rows: 3,
  showTime: 6,
  answerTime: 10,
  qCount: 10,
  maxNumber: 10,
  digits: 1,
  digits1: 1,
  digits2: 1,
  displaySetting: 0,
  displayShow: 0,
  lessThan0: 0
}

function searchLabel(array, value) {
  let rel = '';
  let index = array.findIndex(a => a.value == value);
  if (index > -1) {
    rel = array[index].label;
  }
  return rel;
}
let _this;
const DWIDTH = 980;

class Marathon extends Component {
  constructor() {
    super();
    _this = this;
    this.state = { wWidth: 0, wHeight: 0,setting:{}, message: '',loading:true,rows:3,showSetRow:false, curWeek: -1, curDay: -1, course: null,result:{}};
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  handleChange = name => event => {

    event.preventDefault();
    this.setState({
      [name]: event.target.value

    });
  }

  async loadCourse() {
    let ACCOUNT = store.getState().ACCOUNT;
    //console.log(ACCOUNT.idkhoahoc)
    try {
      let sACC = false;

        let aDoc =  await firebase.firestore().collection('data_students').doc('data_students-'+ACCOUNT.id).get();
        if(aDoc.exists){
          sACC = aDoc.data();
          sACC.type = 0;
          localStorage.setItem('ACCOUNT', JSON.stringify(sACC));
          store.dispatch({ type: 'ACCOUNT', ACCOUNT:sACC });
        }
        let sDoc = await firebase.firestore().collection('Marathon').doc("#Setting").get();
        //console.log(sDoc.exists)
        if(sDoc.exists)
        {
          let setting = sDoc.data();
          setting.id = sDoc.id;
          if(moment(setting.endTime).isBefore(moment())||moment(setting.startTime).isAfter(moment()))
          {
            STATIC.NotificationManager.error(this.props.t("common.marathon_over",{name:setting.name}));
           _this.props.history.push('/');
           return;
          }
          _this.setState({setting});

        }
        else {
          _this.props.history.push('/');
          return;
        }

      let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
      if (data.size>0) {
        let item = {};
        data.forEach((doc)=>{
          item = doc.data();
          item.id = doc.id;
        })
        if (item.weeks&&item.MarathonSetting)
        {
          // let doc =  await firebase.firestore().collection("data_students").doc("data_students"+'-'+ACCOUNT.id).collection('lastdays').doc(item.id).get();
          //
          // let LASTDAY = {week:0,day:1}
          // if(doc.exists)
          // {
          //   LASTDAY = doc.data();
          // }
          // console.log(item.id);
          //
          // store.dispatch({ type: 'LASTDAY', LASTDAY });

          let fromdate = item.startDate;
          let todate = item.endDate;

          if(sACC)
          {
            lastday = STATIC.getBusinessDays(moment(),moment(sACC.fromdate));
            fromdate = sACC.fromdate;
            todate = sACC.todate;
          }

          fromdate = moment(fromdate);
          todate = fromdate.clone().add(item.week*7,"days");;

          //let todate = fromdate.add(item.week*7,"days");


        //  console.log(1,todate.format("L"),fromdate.format("L"));

          let hData =  await firebase.firestore().collection("data_holiday").where('idchinhanh','==',ACCOUNT.idchinhanh).orderBy("fromdate").get();
          let items = [];
          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              items.push(hItem);
            })

            let checkDate = STATIC.checkTodate(items,fromdate,todate,item.week);
            todate = checkDate.todate;
            fromdate = checkDate.fromdate;
          }
          if(moment().isSameOrBefore(todate))
          {
            todate = moment();
          }
          //console.log(2,todate.format("L"),fromdate.format("L"));
          let lastday = STATIC.getBusinessDays(todate,fromdate);
          //console.log(lastday);
          let holiday = 0;



          if(hData.size>0)
          {

            hData.forEach(hDoc=>{
              let hItem = hDoc.data();
              if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')||moment(hItem.todate).isBetween(fromdate,todate,'day','[]')||(fromdate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]')&&todate.isBetween(moment(hItem.fromdate),moment(hItem.todate),'day','[]'))){

                let tHoliday = 0;
                if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]')&&moment(hItem.todate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),moment(hItem.fromdate));

                }
                else if(moment(hItem.fromdate).isBetween(fromdate,todate,'day','[]'))
                {
                  tHoliday = STATIC.getBusinessDays(todate,moment(hItem.fromdate));

                }
                else if(moment(hItem.todate).isBetween(fromdate,todate,'day','[]')) {
                  tHoliday = STATIC.getBusinessDays(moment(hItem.todate),fromdate);
                }
                else {
                  tHoliday = lastday;
                }
                //console.log(tHoliday);
                holiday+=tHoliday;
              }
            })
          }
        //  console.log(lastday,holiday);
          //console.log(sACC.fromdate,lastday);
          lastday = lastday - holiday;
        //  console.log(lastday);
          if(lastday<0)
          lastday = 0;
        //  console.log(lastday,moment().format(),moment(sACC.fromdate,'MM/DD/YYYY hh:mm:ss A').format());
          let cWeek = Math.ceil((lastday+1)/6)-1;
          let cDay = lastday%6;
          //cWeek = 12;
          //console.log(cWeek,item.week-1);
          if(cWeek>item.week-1){
            cWeek = item.week-1;
            cDay = 5;
          }
          item.cWeek = cWeek;
          item.cDay = cDay;
          //console.log(cWeek,cDay)

          let selectedDay = item.weeks["w" + cWeek]["d" + (cDay)];
          let type = selectedDay.type[0];
          let mName =  "Flashcard";
          let sMSetting = sACC.MSetting||{};

          let MSetting = null;
          //console.log(type);
          if(type=="image"||type=="soroban")
          {
            type = [type];
            mName = "Flashcard";
          }
          else
          if(type=="LB_0")
          {
            type = [type];
            mName= "Basic";
          }else
          if(type=="LB_1"||type=="LB_2"||type=="LB_3"||type=="LB_4"||type=="LB_-1"||type=="LB_-2"||type=="LB_-3"||type=="LB_-4")
          {
            type = ["LB_1","LB_2","LB_3","LB_4"];
            mName= "LB+";
          }else
          if(type=="LB_-1"||type=="LB_-2"||type=="LB_-3"||type=="LB_-4")
          {
            type = ["LB_-1","LB_-2","LB_-3","LB_-4"];
            mName= "LB-";
          }else
          if(type=="BB_1.1"||type=="BB_2.1"||type=="BB_3.1"||type=="BB_4.1"||type=="BB_5.1"||type=="BB_6.1"||type=="L&B_6.2"||type=="BB_7.1"||type=="L&B_7.2"||type=="BB_8.1"||type=="L&B_8.2"||type=="BB_9.1"||type=="L&B_9.2")
          {
            type = ["BB_1.1","BB_2.1","BB_3.1","BB_4.1","BB_5.1","BB_6.1","BB_7.1","BB_8.1","BB_9.1","L&B_6.2","L&B_7.2","L&B_8.2","L&B_9.2"];
            mName= "BB+";
          }else
          if(type=="BB_-1.1"||type=="BB_-2.1"||type=="BB_-3.1"||type=="BB_-4.1"||type=="BB_-5.1"||type=="BB_-6.1"||type=="L&B_-6.2"||type=="BB_-7.1"||type=="L&B_-7.2"||type=="BB_-8.1"||type=="L&B_-8.2"||type=="BB_-9.1"||type=="L&B_-9.2")
          {
            type = ["BB_-1.1","BB_-2.1","BB_-3.1","BB_-4.1","BB_-5.1","BB_-6.1","BB_-7.1","BB_-8.1","BB_-9.1","L&B_-6.2","L&B_-7.2","L&B_-8.2","L&B_-9.2"];
            mName= "BB-";
          }
          else {
            type = ["LB_1","LB_2","LB_3","LB_4","LB_-1","LB_-2","LB_-3","LB_-4","BB_1.1","BB_2.1","BB_3.1","BB_4.1","BB_5.1","BB_6.1","BB_7.1","BB_8.1","BB_9.1","L&B_6.2","L&B_7.2","L&B_8.2","L&B_9.2","BB_-1.1","BB_-2.1","BB_-3.1","BB_-4.1","BB_-5.1","BB_-6.1","BB_-7.1","BB_-8.1","BB_-9.1","L&B_-6.2","L&B_-7.2","L&B_-8.2","L&B_-9.2"];
            mName= "+/-";
          }


          let find = item.MarathonSetting.find(f=>f.name==mName);
          if(find)
          {
            let rows = _this.state.rows;
            MSetting = {type,rows,...find};
            if(sMSetting.name==MSetting.name)
            {
              MSetting={...MSetting,rows:sMSetting.rows};
              _this.setState({rows:MSetting.rows});
            }
            // else {
            //   if(mName!="Flashcard")
            //   _this.setState({showSetRow:true});
            // }
          }
          console.log(MSetting);
          if(mName!="Flashcard")
          _this.setState({showSetRow:true});
          _this.setState({selectedDay,MSetting});
          await STATIC.postFormData(STATIC.API_STUDENT_MARATHON,{id:sACC.id,MSetting:JSON.stringify(MSetting)});
        //  console.log(sACC.id);
        aDoc =  await firebase.firestore().collection('data_students').doc('data_students-'+ACCOUNT.id).get();
        if(aDoc.exists){
          sACC = aDoc.data();
          sACC.type = 0;
          localStorage.setItem('ACCOUNT', JSON.stringify(sACC));
          store.dispatch({ type: 'ACCOUNT', ACCOUNT:sACC });
        }

          _this.setState({ course: item });
        }
        else {
          _this.props.history.push('/');
          return;
        }


      }
    }
    catch(e)
    {
      console.log(e);
    }

    _this.setState({loading:false});

  }

  getStar(result) {

    let curStar = 0;
    let curMin = 100;
    for (let i = 0; i < 7; i++) {
      let newMin = Math.abs(i / 6 * 100 - result);
      console.log(newMin);
      if (newMin < curMin) {
        curStar = i / 2;
        curMin = newMin;
      }
    }
    if (curStar == 3 && result != 100)
      curStar = 2.5;
    return curStar;
  }

  async componentDidMount() {
    //console.log(moment().add(27,"hours").endOf("days").diff(moment().endOf("days"),"days"));
    //console.log('Business',days);
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let checked = await STATIC.checkVersion();
    if(checked!=true)
    {
      //console.log(checked);
      store.dispatch({ type: 'UP_VER', UP_VER: checked });
    }
    let ACCOUNT = store.getState().ACCOUNT;
    if(ACCOUNT.type!=0||!ACCOUNT.idlop)
    {
      this.props.history.push('/');
      return;
    }

        let diff = moment(ACCOUNT.todate).diff(moment(), 'days');

        if(diff<=-10)
        {
          let data = await firebase.firestore().collection('courses').where('course_id','==',ACCOUNT.idkhoahoc).get();
          let week = 12;
          if (data.size>0) {
            let item = {};
            data.forEach((doc)=>{
              item = doc.data();
              week = item.week;
            })
          }
          let fromdate = moment(ACCOUNT.fromdate);
          let todate = moment(ACCOUNT.fromdate).add(week*7,"days");
          diff = todate.diff(moment(), 'days');
          //console.log(fromdate,week,todate.format("LLLL"));
          if(moment().isAfter(todate))
          {

            let hData =  await firebase.firestore().collection("data_holiday").where('idchinhanh','==',ACCOUNT.idchinhanh).orderBy("fromdate").get();
            if(hData.size>0)
            {
              let items = [];
              hData.forEach(hDoc=>{
                let hItem = hDoc.data();
                items.push(hItem);
              })
              let checkDate = STATIC.checkTodate(items,fromdate,todate,week)
              todate = checkDate.todate;
            }
            diff = todate.diff(moment(), 'days');
            //console.log(diff,todate.format());
            if(diff<=-10)
            {

             STATIC.NotificationManager.error(this.props.t("practice.course_expired",{date:todate.format("DD/MM/YYYY")}));
              this.props.history.push('/');
              return;
            }

          }

        }

    this.loadCourse();

  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ wWidth: window.innerWidth, wHeight: window.innerHeight });
  }


  getFinishForWeek(t) {
    return 0;
    return 6 - t % 6 == 0 ? 1 : 6 - t % 6;
  }
  getStarForDay(t, size = 30) {
    let array = [];
    for (let i = 1; i <= 3; i++) {
      let item = (<StarIcon key={i} style={{ fontSize: size }} />);
      if (i > t) {
        item = (<StarBorderIcon key={i} style={{ fontSize: size }} />);
      }
      array.push(item);
    }
    return array;
  }
  async onLessonEnd(questions) {
    //console.log(questions);
    let count = 0;
    let countCorrect = 0;
    for (let q of questions) {
      if (q.status) {
        count++;
        if (q.status == 1) {
          countCorrect++;
        }
      }
    }
    let MSetting = _this.state.MSetting;
    let passPercent = MSetting.percent?MSetting.percent:80;

    let percent = Math.round(countCorrect / questions.length * 100);
    let ACCOUNT = store.getState().ACCOUNT;
    let nResult = {id_student:ACCOUNT.id,percent,name:ACCOUNT.ten,mahs:ACCOUNT.mahs,type:MSetting.name,rows:parseInt(MSetting.rows),qCount:questions.length,showTime:MSetting.showTime};
    //console.log(nResult);
    if(percent>=passPercent)
    {
      _this.postResultToServer(nResult);
    }
    _this.setState({ showResult: true,result:{percent,passPercent,countCorrect,qlength: questions.length,questions},nResult });
    return;

    // if(count==countCorrect&&count==questions.length)
    // {
    //   _this.setState({showSignUp:true});
    // }



  }
  async postResultToServer(result){
  //  console.log("post result");
  if(!result)
  {
    _this.setState({saving:false,saving_error:false});
    return;
  }
 await  _this.setState({saving:true,saving_error:false});

    //console.log(JSON.stringify(result));
    //return;
    //let res = await STATIC.postFormData("http://localhost:5000/vnsuperbrain/us-central1/Student_PostResultAdvance2",{result:JSON.stringify(result)});
    let res = await STATIC.postFormData(STATIC.API_STUDENT_MARATHONRESULT,{result:JSON.stringify(result)});
    //console.log(res);
    if(res)
    {
      if(res.status==0)
      {
        await  _this.setState({saving_error:true});

      }
      else {

        let ACCOUNT = store.getState().ACCOUNT;
        //console.log(ACCOUNT.idkhoahoc)

            let aDoc =  await firebase.firestore().collection('data_students').doc('data_students-'+ACCOUNT.id).get();
            let addDay = 0;
            if(aDoc.exists){
              let sACC = aDoc.data();
              sACC.type = 0;
              localStorage.setItem('ACCOUNT', JSON.stringify(sACC));
              store.dispatch({ type: 'ACCOUNT', ACCOUNT:sACC });
              if(sACC.MarathonCDay!=ACCOUNT.MarathonCDay&&sACC.MarathonCDay>(ACCOUNT.MarathonCDay||0))
              {
                console.log("addDay");
                addDay=1;
              }
            }
            await  _this.setState({saving:false,addDay});
      }
    }
    else {
      await  _this.setState({saving_error:true});
    }
  }

  backClick() {

      this.props.history.push('/');

  }
  onCloseModal(e) {
    _this.setState({ showResult: false, curDay: -1 })
  }

getQuestionEQ(question,width)
{
  let rel = '';
  if(question.type!="image"&&question.type!="soroban")
  {

    for(let num of question.numbers)
    {
      if(question.type!='multiple'&&question.type!='divide')
      {
        if(rel=='')
        {
          rel=num;
          continue;
        }
        else {
          rel += (num>=0?' + ':' - ')+Math.abs(num);
        }
      }
      else {
        if(rel=='')
        {
          rel+=num;
        }
        else {
          rel+=""+num;
        }
      }

    }
  }
  else
  if(question.type=="soroban")
  {
    rel = "Soroban";
  }
  else {
    rel = (<div style={{display:'inline-block'}}>{question.images.map((i,index)=>{
      i = i.replace('_','-');
      i = i.replace('finger/f','finger/');
      return (<img key={"image"+index}
  src={i}
  style={{width: STATIC.calSize(30, STATIC.DWIDTH, width), height: 'auto'}} />)
    })}

    </div>)
  }
  return rel;
}

changeResult(index)
{
  let {fResults} = _this.state;
  if(index<=fResults.length-1&&index>=0)
  {
    _this.setState({result:fResults[index],rIndex:index});
  }
}

handleChangeDigits = (name,max) => event => {

  let value = event.target.value;
  if(value>max)
  {
    value=max;
  }

  this.setState({
    [name]: value
  });

}
async saveMSetting()
{let ACCOUNT = store.getState().ACCOUNT;
  await STATIC.postFormData(STATIC.API_STUDENT_MARATHON,{id:ACCOUNT.id,MSetting:JSON.stringify(_this.state.MSetting)});
}
  render() {
    const { classes,t } = this.props;
    const { wWidth, wHeight,loading,setting, curWeek, curDay, showResult, course,result,showAdvance,showResultDetail,title,showChart,showInner,isGuest,legends,saving,saving_error } = this.state;
    let width = DWIDTH;
    if (wWidth < DWIDTH) {
      width = wWidth;
    }
    let sRate = 980 / 690;;

    if (width / wHeight > sRate) {
      width = wHeight * sRate;
    }
    if(showResult)
    {
      let rRate = 800/722;
      if (width / wHeight > rRate) {
        width = wHeight * rRate;
      }
      //console.log(wHeight * rRate);
    }
    let fBig = width * 0.08;
    let fLarge = width * 0.06;
    let fTitle = width * 0.04;
    let fNormal = width * 0.03;
    let fSmall = width * 0.02;
    let fSmaller = width * 0.015;
    let bRate = 391 / 271;

    let bWidth = width / 3;
    let bHeight = bWidth / bRate;
    let bConWidth = bWidth * 0.25 * 10;
    let weeks = [];
    if (course) {

      for (let i = 0; i < course.week; i++) {
        weeks.push(i);
      }

    }

    let LASTDAY = store.getState().LASTDAY;


    let ACCOUNT = store.getState().ACCOUNT;
    if (!ACCOUNT) {

      return (<Redirect to='/login' />);
    }
    let MarathonCDay = ACCOUNT.MarathonCDay||0;
    let MarathonTDay = ACCOUNT.MarathonTDay||0;
    let MarathonTotal = 0;
    if(setting&&setting.rewards)
    {
      MarathonTotal = setting.rewards[setting.rewards.length-1]['day'];
    }
    //console.log(MarathonCDay,MarathonTotal);
    let LANG = store.getState().LANG;
    if (loading) {

      return (<div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              <div style={{ marginBottom: STATIC.calSize(curWeek > -1 && curDay > -1 ? 10 : 30, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{setting.name&&setting.name.length>0?setting.name:""}</div>
                </div>

                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

              </div>
              <div style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}}>

                  <div>
                  <CircularProgress style={{color:'rgb(5, 63, 34)'}}/>
                  </div>

              </div>
              <Link to="/" style={{ width: '100%' }}>
                <img
                  src={setting.logo_img&&setting.logo_img.length>0?setting.logo_img:""}
                  style={{ maxWidth: 296, height: 'auto', width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>
            </div></div>
          </div>
        </div>);
    }
    if(showAdvance||ACCOUNT.type==1||isGuest){
      return (<Advance g_practice={isGuest?this.state.g_practice:false} onClose={ACCOUNT.type==1||isGuest?null:()=>this.setState({showAdvance:false})} history={this.props.history} parentPath="/practice" />);
    }
    if(showInner){
      return (<InnerPage onEnd={()=>this.onInnerEnd()} timer={showInner.innerTime}  />);
    }

    return (
      <div className={classes.root} style={{backgroundImage:"url('"+store.getState().BG+"')"}}>
        <div className={classes.middle}>
<TopBar width={width} screen={"practice"} />
          <div className={classes.square} style={{ maxWidth: width }} elevation={4}>
            <div style={{ padding: (STATIC.calSize(40, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(20, STATIC.DWIDTH, width) + 'px 0'), flexGrow: 1, position: 'relative' }}>
              <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(255, 255, 255, 0.8)', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), zIndex: -1 }} />
              <div style={{ marginBottom: STATIC.calSize( 10, STATIC.DWIDTH, width) }}>
                <div style={{ display: 'flex' }}>
                  <ButtonBase
                    focusRipple
                    onClick={() => this.backClick()}
                    style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), backgroundColor: 'rgb(0, 104, 56)', display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                    <BackIcon style={{ color: 'white', fontSize: fTitle }} />
                  </ButtonBase>
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fTitle }}>{setting.name&&setting.name.length>0?setting.name:""}</div>

                </div>

                <Divider style={{ marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), marginBottom: STATIC.calSize(5, STATIC.DWIDTH, width), backgroundColor: "#053f22", height: STATIC.calSize(2, STATIC.DWIDTH, width) }} variant="middle" />

              </div>
              {setting&&<div style={{display:"flex",flexDirection:"row" }}>
              <div>
              <div style={{ height: STATIC.calSize(40, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>

              </div>
              <div style={{ height: STATIC.calSize(40, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden',color:'rgb(5, 63, 34)' }}>
                <img
                  src="assets/web/m_soroban.png"
                  style={{  height: STATIC.calSize(40, STATIC.DWIDTH, width), width: 'auto' }} />
              </div>
              </div>
              <div style={{flexGrow:1}}>
                <div style={{ height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>
                  {setting.rewards.map((r,index)=>{
                    let last = index==(setting.rewards.length-1);

                    return (<ButtonBase
                      key={index}
                      focusRipple
                      style={{position:'absolute',top:0,left:((r.day/MarathonTotal)*100)+"%",marginLeft:-(STATIC.calSize(40, STATIC.DWIDTH, width)/(last?1:2)), width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>
                      <StarIcon style={{ color: r.day<=MarathonTDay?'gold':'#ece1a5', fontSize: r.day<=MarathonTDay?fBig:fLarge }} />
                      <div style={{position:"absolute",display:"flex",justifyContent:'center',alignItems:'center',top:0,right:0,bottom:0,left:0,color:'rgb(5, 63, 34)',fontSize:r.day<=MarathonTDay?fNormal:fSmall}}><div>{r.day}</div></div>
                    </ButtonBase>)
                  })}
                </div>
                <div style={{ backgroundColor: 'rgb(253, 206, 7)', border: '2px solid rgb(5, 63, 34)', height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'relative', backgroundColor: 'rgb(101, 163, 67)', height: STATIC.calSize(40, STATIC.DWIDTH, width), width: ((MarathonCDay/MarathonTotal)*100)+"%" }} />
                  <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, height: STATIC.calSize(40, STATIC.DWIDTH, width), textAlign: 'center', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>{t('common.day')} {MarathonCDay}</div>
                  {false&&<ButtonBase
                    focusRipple
                    style={{position:'absolute',top:0,left:((MarathonCDay/MarathonTotal)*100)+"%",marginLeft:-(STATIC.calSize(40, STATIC.DWIDTH, width)/2), width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>

                    <div style={{position:"absolute",display:"flex",justifyContent:'center',alignItems:'center',top:0,right:0,bottom:0,left:0,color:'white',fontSize:fNormal}}><div>{MarathonCDay}</div></div>
                  </ButtonBase>}
                  {false&&setting.rewards.map((r,index)=>{

                    return (<div
                      style={{position:'absolute',top:0, backgroundColor: 'rgb(101, 163, 67)',left:((r.day/MarathonTotal)*100)+"%",marginLeft:-(STATIC.calSize(4, STATIC.DWIDTH, width)/2), width: STATIC.calSize(4, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width), display: 'flex', justifyContent: 'center', alignItems: 'center', cursor: 'pointer' }}>                    </div>)
                  })}
                </div>
                </div>
                <div>
                <div style={{ height: STATIC.calSize(40, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>

                </div>
                <div style={{ height: STATIC.calSize(40, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden',color:'rgb(5, 63, 34)' }}>
                  <img
                    src="assets/web/m_soroban_end.png"
                    style={{  height: STATIC.calSize(40, STATIC.DWIDTH, width), width: 'auto' }} />
                </div>
                </div>
              </div>}

              <div style={{display:'flex',marginTop: STATIC.calSize( 10, STATIC.DWIDTH, width),flexDirection:'row',justifyContent:'center'}}>
                <Button onClick={()=>this.setState({showSetRow:true})}  style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmaller}}>
                    {this.state.MSetting.name}/{this.state.MSetting.rows}R/{this.state.MSetting.showTime}S/{this.state.MSetting.qCount}Q
                  </div>
                </Button>
                <div style={{flexGrow:1}}></div>



              </div>
              {this.state.MSetting&&!this.state.showSetRow&&<div>
                <LessonComp
                  {...this.state.MSetting}
                  showAdvance={false}
                  updateTitle={(title)=>this.setState({title})}
                  onLessonEnd={this.onLessonEnd}
                  pWidth={width}
                />
              </div>}
              <div style={{display:"flex",flexDirection:'row'}}>
                <Button onClick={()=>this.setState({showSetRow:true})}  style={{ color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmall}}>
                    {t('common.setting')}
                  </div>
                </Button>
                <Button onClick={()=>this.props.history.push("/marathon_ranking")}  style={{ color: "#053f22",marginLeft:STATIC.calSize(20, STATIC.DWIDTH, width), padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                  <div style={{ textAlign: 'center', margin: 0, color: 'rgb(5, 63, 34)', fontFamily: 'UTMP', flexGrow: 1, fontSize: fSmall}}>
                    {t('common.ranking')}
                  </div>
                </Button>
              </div>

              <Link to="/" style={{ width: '100%' }}>
                <img
                  src={setting.logo_img&&setting.logo_img.length>0?setting.logo_img:""}
                  style={{ maxWidth: 296, height: 'auto', width: STATIC.calSize(189, STATIC.DWIDTH, width) }} />
              </Link>


            </div>
            <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>this.setState({showSetRow:false})} showCloseIcon={false} focusTrapped={false} open={this.state.showSetRow} center>
              <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
                <div style={{ display: 'flex',flexDirection:'column',justifyContent:'center',alignItems:'center' }}>

                    <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.set_rows')}</div>
                      <div style={{ display: 'inline-block', color: 'rgb(5, 63, 34)', marginLeft: 5, width: width * 0.15 }}>
                        <input
                          onChange={this.handleChangeDigits('rows',40)}
                          value={this.state.rows}
                          type="number"
                          min={3}
                          max={40}
                          placeholder=""
                          style={{ border: 'none', textAlign: 'center', width: '100%', padding: STATIC.calSize(10, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(15, STATIC.DWIDTH, width) + 'px', color: 'rgb(5, 63, 34)', fontSize: fNormal }} />

                      </div>
                    <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>


                      <Button onClick={()=>{_this.state.MSetting.rows=_this.state.rows;this.setState({showSetRow:false},()=>this.saveMSetting())}} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                        {t('common.save')}
                      </Button>

                    </div>
                    </div>
                  </div>
                </Modal>
                <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={showResult&&!saving&&!saving_error} onClose={() => this.setState({ showResult: false })} center>
                  <div style={{ width: width * 0.8, backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                    <div style={{ width: width * 0.8 - STATIC.calSize(10, STATIC.DWIDTH, width) * 2, minHeight: 50, borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), border: '1px solid white', textAlign: 'center' }}>
                      <img
                        src={result.percent>=result.passPercent?"assets/web/icon_soroban_good.png":"assets/web/icon_soroban_bad.png"}
                        style={{ width: width * 0.3, height: 'auto', marginTop: STATIC.calSize(-63, STATIC.DWIDTH, width) }} />
                      <div style={{ color: 'white', fontSize: fLarge, fontWeight: 'bold' }}>
                        {result.percent>=result.passPercent?t('common.congratulation')+"!":t('common.tryagain')}
                                      </div>
                                      {result.percent>=result.passPercent&&this.state.addDay==1?<div style={{color: 'rgb(5, 63, 34)', fontWeight: 'bold', fontSize: fLarge}}>
    +1 {t('common.day')}
    </div>:false}


                      {result.percent>=result.passPercent?(<div style={{ display: 'flex', justifyContent: 'center', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
                      <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }}
                         color="primary" size="medium" variant="contained" onClick={() => this.setState({ showResult: false,isMore:1 })}>
                        {t('common.more')}
                            </Button>
                    </div>):(<div style={{ display: 'flex', justifyContent: 'center', padding: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%' }}>
                        <Button style={{ color: "#053f22", borderRadius: STATIC.calSize(25, STATIC.DWIDTH, width), padding: (STATIC.calSize(8, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(24, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontSize: fNormal }} color="primary" size="medium" variant="contained" onClick={() => this.setState({showResult: false })}>
                          {t('common.resume')}
                              </Button>
                      </div>)}
                    </div>
                  </div>
                  <div style={{ display: 'flex', padding: STATIC.calSize(18, STATIC.DWIDTH, width), width: '100%' }}>
                    <div style={{ flexGrow: 1, padding: '0px '+STATIC.calSize(10, STATIC.DWIDTH, width)+'px' }}>
                      <div style={{ backgroundColor: 'rgb(253, 206, 7)', border: '2px solid white', height: STATIC.calSize(40, STATIC.DWIDTH, width), borderRadius: STATIC.calSize(20, STATIC.DWIDTH, width), width: '100%', position: 'relative', overflow: 'hidden' }}>
                        <div style={{ position: 'relative', backgroundColor: 'rgb(101, 163, 67)', height: STATIC.calSize(40, STATIC.DWIDTH, width), width: result.percent+'%' }} />
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, height: STATIC.calSize(40, STATIC.DWIDTH, width), textAlign: 'center', fontSize: fTitle, color: 'rgb(5, 63, 34)' }}>{result.percent}%</div>
                      </div>
                    </div>
                    <div onClick={()=>this.setState({showResultDetail:true})}>
                      <img
                        src="assets/web/icon_result.png"
                        style={{ width: STATIC.calSize(40, STATIC.DWIDTH, width), height: STATIC.calSize(40, STATIC.DWIDTH, width)}} />
                    </div>
                  </div>
                  <div style={{ position: 'fixed', bottom: STATIC.calSize(50, STATIC.DWIDTH, width), left: 0, right: 0, textAlign: 'center' }}>
                    <img
                      src={setting.logo_img&&setting.logo_img.length>0?setting.logo_img:""}
                      style={{ width: width * 0.2, maxWidth: 296, height: 'auto', marginBottom: STATIC.calSize(-50, STATIC.DWIDTH, width), marginTop: STATIC.calSize(20, STATIC.DWIDTH, width) }} />
                  </div>

                </Modal>
                <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'white',textAlign:'center' } }} open={showResultDetail} onClose={() => this.setState({ showResultDetail: false })} center>
                  <div>
                      {result.created?<div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>
                      {_this.state.rIndex>0?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginRight:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex-1)}>
                          {"<"}
                        </Button>:false}
                      <div style={{fontSize: fSmall}}>{moment(result.created).format("DD/MM/YYYY HH:mm")}</div>
                    {_this.state.rIndex<_this.state.fResults.length-1?<Button style={{ color: "#053f22", borderRadius: STATIC.calSize(5, STATIC.DWIDTH, width), padding: (STATIC.calSize(1, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(5, STATIC.DWIDTH, width) + 'px'),marginLeft:STATIC.calSize(10, STATIC.DWIDTH, width),backgroundColor:'white', minWidth: 0, fontSize: fSmall }} color="primary" size="medium" variant="contained" onClick={() => this.changeResult(this.state.rIndex+1)}>
                        {">"}
                      </Button>:false}</div>:false}
                        <Grid container direction="row" style={{marginTop:STATIC.calSize(40, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(20, STATIC.DWIDTH, width)}} >
                            <Grid item xs={1} >
                              <div style={{fontSize: fSmall}}>{t('common.id')}</div>
                            </Grid>
                            <Grid item xs={5} >
                              <div style={{fontSize: fSmall,textAlign:'left'}}>{t('common.question')}</div>

                            </Grid>
                            <Grid item xs={2} >
                              <div style={{fontSize: fSmall}}>{t('common.input')}</div>

                            </Grid>
                            <Grid item xs={2} >
                              <div style={{fontSize: fSmall}}>{t('common.correct')}</div>

                            </Grid>
                            <Grid item xs={2} >
                              <div style={{fontSize: fSmall}}>{t('common.result')}</div>
                            </Grid>
                        </Grid>
                        <Divider />
                        {result&&result.questions?result.questions.map((q,index)=>{
                          return (<Grid key={index} container direction="row" style={{marginTop:STATIC.calSize(10, STATIC.DWIDTH, width),marginBottom:STATIC.calSize(10, STATIC.DWIDTH, width)}} >
                              <Grid item xs={1} >
                                <div style={{fontSize: fSmall}}>{index+1}</div>
                              </Grid>
                              <Grid item xs={5} >
                                <div style={{fontSize: fSmall,textAlign:'left'}}>{this.getQuestionEQ(q,width)} =</div>

                              </Grid>
                              <Grid item xs={2} >
                                <div style={{fontSize: fSmall}}>{q.answer}</div>

                              </Grid>
                              <Grid item xs={2} >
                                <div style={{fontSize: fSmall}}>{q.result}</div>

                              </Grid>
                              <Grid item xs={2} >
                                <div style={{fontSize: fNormal,color:q.status==1?'green':"red"}}>{q.status==1?<CheckIcon style={{fontSize:fNormal}}/>:"X"}</div>
                              </Grid>
                          </Grid>)
                        }):false}
                        <Divider />
                        <div style={{textAlign: 'right', fontSize: fSmall, marginTop: STATIC.calSize(10, STATIC.DWIDTH, width)}}>{t('common.total')}: {result.countCorrect}/{result.qlength}<br />({result.percent}%)</div>
                      <div style={{textAlign: 'left', marginTop: STATIC.calSize(40, STATIC.DWIDTH, width)}}>
                        <img
                        src="assets/web/logo_green.png"
                        style={{width: width*0.2, maxWidth: 296, height: 'auto'}} />
                        </div>

                  </div>
                </Modal>
                <Modal styles={{overlay:{padding:0}, modal: { background: 'none',textAlign:'center' } }} onClose={()=>{}} showCloseIcon={false} focusTrapped={false} open={saving_error} center>
                  <div style={{ width: "100%", backgroundColor: 'rgba(101, 163, 67, 1)', position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH), padding: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH) }}>
                    <div style={{ display: 'flex',flexDirection:'column' }}>

                        <div style={{textAlign: 'center', fontSize: fNormal, marginTop: STATIC.calSize(10, STATIC.DWIDTH, STATIC.DWIDTH)}}>{t('common.saving_error')}</div>
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center', marginTop: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                          <Button onClick={()=>this.setState({saving:false,saving_error:false})} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                            {t('common.close')}
                          </Button>
                          <div style={{flexGrow:1}}></div>
                          <Button onClick={()=>this.postResultToServer(this.state.nResult)} style={{marginTop: STATIC.calSize(5, STATIC.DWIDTH, width), color: "#053f22", padding: (STATIC.calSize(6, STATIC.DWIDTH, width) + 'px ' + STATIC.calSize(16, STATIC.DWIDTH, width) + 'px'), minWidth: 0, backgroundColor: '#fdce07', fontWeight: 'bold', fontSize: fSmall, display: 'block', textTransform: "capitalize", fontWeight: 'normal' }} size="large" variant="contained"  >
                            {t('common.saving_retry')}
                          </Button>

                        </div>
                        </div>
                      </div>
                    </Modal>
                    <Modal styles={{overlay:{padding:0}, modal: { minWidth: width * 0.8, background: 'none', boxShadow: 'none', color: "white" } }} showCloseIcon={false} focusTrapped={false} open={saving&&!saving_error} onClose={() => this.setState({ })} center>
                      <div style={{ width: width * 0.8, position: 'relative', borderRadius: STATIC.calSize(10, STATIC.DWIDTH, width), padding: STATIC.calSize(10, STATIC.DWIDTH, width) }}>
                        <div style={{textAlign:'center'}}>
                        <CircularProgress style={{color:'white'}}/>
                        <div style={{fontSize:fNormal}}>{t('common.save_result')}</div>
                        </div>
                      </div>
                    </Modal>


          </div>


        </div>

      </div>
    );
  }
}


Marathon.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(STATIC.styles)(STATIC.translate('common')(Marathon));
